import Box from "ds/components/Box";
import Button from "ds/components/Button";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import useTypedContext from "hooks/useTypedContext";
import { showModuleVersionInstructionsDrawer } from "views/Account/Module/Version/components/InstructionsDrawer";
import { VersionContext } from "views/Account/Module/Version/Context";

import { ModuleVersionSubmoduleRow } from "../types";

const ModuleVersionSubmodulesTableInstructionsCell = ({
  item: submodule,
  ...cellProps
}: TableSimpleCellProps<ModuleVersionSubmoduleRow>) => {
  const { version, module } = useTypedContext(VersionContext);

  const handleOpenInstructions = () => {
    showModuleVersionInstructionsDrawer({
      id: submodule.id,
      moduleName: submodule.id,
      inputs: submodule.inputs,
      versionNumber: version.number,
      type: "submodule",
      workflowTool: module.workflowTool,
      moduleSource: module.moduleSource,
      submodulePath: submodule.path,
    });
  };

  return (
    <TableSimpleCell {...cellProps}>
      <Box align="center">
        <Button
          variant="secondary"
          size="small"
          aria-label="Show instructions"
          onPress={handleOpenInstructions}
        >
          Instructions
        </Button>
      </Box>
    </TableSimpleCell>
  );
};

export default ModuleVersionSubmodulesTableInstructionsCell;
